import { render, staticRenderFns } from "./section.vue?vue&type=template&id=b00618f4&scoped=true"
import script from "./section.vue?vue&type=script&lang=ts"
export * from "./section.vue?vue&type=script&lang=ts"
import style0 from "./section.vue?vue&type=style&index=0&id=b00618f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00618f4",
  null
  
)

export default component.exports